// components/UseCasesSection.jsx
import React from "react";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import MovieIcon          from "@mui/icons-material/Movie";
import YouTubeIcon        from "@mui/icons-material/YouTube";
import MicIcon            from "@mui/icons-material/Mic";
import RadioIcon          from "@mui/icons-material/Radio";
import SportsEsportsIcon  from "@mui/icons-material/SportsEsports";
import { Reveal }         from "../lib/hooks";

const USE_CASES = [
  {
    Icon: BusinessCenterIcon,
    title: "Ad Agencies & Brands",
    body: "TV commercials. Digital ads. Corporate films. Brand documentaries. Product launch videos. Event films. Internal communications. Radio spots.",
  },
  {
    Icon: MovieIcon,
    title: "Film & Broadcast",
    body: "Trailers & teasers. Title sequences. End credits. TV series themes. Episode beds. Documentary scores. News. Sports. Reality TV.",
  },
  {
    Icon: YouTubeIcon,
    title: "YouTube & Social",
    body: "Channel ID sting. Intro & outro music. Background underscores. Vlog soundtracks. Tutorial backgrounds. Short-form reels & Shorts.",
  },
  {
    Icon: MicIcon,
    title: "Podcast Creators",
    body: "Intro & outro themes. Episode underscores. Transition stings. Sponsor beds. Interview backing music. Branded show music.",
  },
  {
    Icon: RadioIcon,
    title: "Radio",
    body: "Radio spots. Jingles. Station IDs. Promos. News beds. Traffic and weather beds. Imaging packages.",
  },
  {
    Icon: SportsEsportsIcon,
    title: "Gaming & Animation",
    body: "Background scores. Combat & action cues. Menu & UI sounds. Cutscene music. Victory & defeat stings. Battle themes.",
  },
];

export default function UseCasesSection() {
  return (
    <section className="bg-[#f4f6fb] dark:bg-[#161b22] relative overflow-hidden" style={{background : "rgb(var(--canvas))"}}>
      <div className="section-inner">
        <Reveal>
          <div className="section-label">Who Uses SyncMama</div>
          <h2 className="section-title">
            The music source<br />for every storyteller
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-4 mt-14 md:grid-cols-2 sm:grid-cols-1">
          {USE_CASES.map(({ Icon, title, body }, i) => (
            <Reveal key={title} delay={i * 70}>
              <div className="
                bg-white dark:bg-[#21262d]
                border border-[rgba(27,58,107,0.1)] dark:border-[rgba(255,255,255,0.06)]
                rounded-xl p-7 relative overflow-hidden
                transition-all duration-300 ease-[cubic-bezier(.4,0,.2,1)]
                group cursor-default
                hover:-translate-y-1 hover:border-pink-400
                shadow-none transition-shadow duration-300
                hover:shadow-[0_16px_40px_rgba(27,58,107,0.1)]
                h-full plan-card
              ">
                {/* Accent bar (slide up on hover) */}
                <div className="
                  absolute bottom-0 left-0 right-0 h-0.5
                  bg-gradient-to-r from-pink to-transparent
                  scale-x-0 origin-left group-hover:scale-x-100
                  transition-transform duration-[350ms] ease-[cubic-bezier(.4,0,.2,1)]
                " />

                {/* Icon in circle */}
                <div className="
                  w-14 flex items-center justify-start mb-1
                  transition-all duration-300
                  group-hover:scale-110
                ">
                  <Icon className="use-icon" sx={{ fontSize: 30}} />
                </div>

                <h3 className="use-title mb-2">
                  {title}
                </h3>
                <p className="use-desc">
                  {body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
